import React from 'react';
import '../../styles/anti-ragging/main.css';

const Main = () => {
    return (
        <div id='antiRaggingMain'>
            <div className="container mt-4">
                {/* PDF Files with Clickable Icons and Headings */}
                <div className="row pt-5">
                    <h2 className="my-heading">Anti Ragging</h2>
                    {/* Image Section */}
                    <div className="col-md-6 mb-4">
                        {/* Anti Ragging Grievance Process Flow Chart Image */}
                        <img
                            src="assets\images\flowchart.jpg"
                            alt="Anti Ragging Grievance Process Flow Chart"
                            className="img-fluid"
                            style={{ width: 431, height: 609 }}
                        />
                        {/* Heading: Toll-Free (Anti Ragging Helpline) */}
                        <div>
                            <h2 className="mt-4">Toll-Free (Anti Ragging Helpline)</h2>
                            <p>Phone Number: 1-800-123-4567</p>
                            <p>Email: antiragging@example.com</p>
                        </div>
                    </div>
                    {/* PDF Files Section */}
                    <div className="col-md-6 mb-4">
                        {/* Heading for PDF Files */}
                        {/* <h2>Anti Ragging</h2> */}
                        <br />
                        {/* PDF File Icons */}
                        <div className="row d-flex justify-content-center gap-3">
                            {/* Example PDF File 1 */}
                            <div className="col-md-3 mb-4 lnk-crad">
                                <a
                                    href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/pdf-files/anti-ragging-team-day-wise-academic-session-2022-23.pdf"
                                    target="_blank"
                                    rel="noreferrer"
                                    className="text-dark"
                                >
                                    <i className="fas fa-file-pdf fa-3x pdf-icon" />
                                    <p>Anti Ragging Team</p>
                                </a>
                            </div>
                            <div className="col-md-3 mb-4 lnk-crad">
                                <a
                                    href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/pdf-files/rag-committee-report.pdf"
                                    target="_blank"
                                    rel="noreferrer"
                                    className="text-dark"
                                >
                                    <i className="fas fa-file-pdf fa-3x pdf-icon" />
                                    <p>Committee Report</p>
                                </a>
                            </div>
                            <div className="col-md-3 mb-4 lnk-crad">
                                <a
                                    href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/pdf-files/rag-sc-order.pdf"
                                    target="_blank"
                                    rel="noreferrer"
                                    className="text-dark"
                                >
                                    <i className="fas fa-file-pdf fa-3x pdf-icon" />
                                    <p>UGC Regulation</p>
                                </a>
                            </div>
                            <div className="col-md-3 mb-4 lnk-crad">
                                <a
                                    href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/pdf-files/rag-ugc-notification.pdf"
                                    target="_blank"
                                    rel="noreferrer"
                                    className="text-dark"
                                >
                                    <i className="fas fa-file-pdf fa-3x pdf-icon" />
                                    <p>UGC Notification</p>
                                </a>
                            </div>
                            <div className="col-md-3 mb-4 lnk-crad">
                                <a
                                    href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/pdf-files/rag-sc-committee.pdf"
                                    target="_blank"
                                    rel="noreferrer"
                                    className="text-dark"
                                >
                                    <i className="fas fa-file-pdf fa-3x pdf-icon" />
                                    <p>SC Committee</p>
                                </a>
                            </div>
                            <div className="col-md-3 mb-4 lnk-crad">
                                <a
                                    href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/pdf-files/rag-sc-order.pdf"
                                    target="_blank"
                                    rel="noreferrer"
                                    className="text-dark"
                                >
                                    <i className="fas fa-file-pdf fa-3x pdf-icon" />
                                    <p>SC Order</p>
                                </a>
                            </div>
                            <div className="col-md-3 mb-4 lnk-crad">
                                <a
                                    href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/pdf-files/rag_minutes.pdf"
                                    target="_blank"
                                    rel="noreferrer"
                                    className="text-dark"
                                >
                                    <i className="fas fa-file-pdf fa-3x pdf-icon" />
                                    <p>Minutes of the Meetings</p>
                                </a>
                            </div>
                            <div className="col-md-3 mb-4 lnk-crad">
                                <a
                                    href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/pdf-files/rag_ATR_2022.pdf"
                                    target="_blank"
                                    rel="noreferrer"
                                    className="text-dark"
                                >
                                    <i className="fas fa-file-pdf fa-3x pdf-icon" />
                                    <p>Action Taken Report 2022</p>
                                </a>
                            </div>
                            <div className="col-md-3 mb-4 lnk-crad">
                                <a
                                    href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/pdf-files/rag_committee_report_2022.pdf"
                                    target="_blank"
                                    rel="noreferrer"
                                    className="text-dark"
                                >
                                    <i className="fas fa-file-pdf fa-3x pdf-icon" />
                                    <p>Anti Ragging Committe Report 2022</p>
                                </a>
                            </div>
                            <div className="col-md-3 mb-4 lnk-crad">
                                <a
                                    href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/pdf-files/Anti-ragging-policy.pdf"
                                    target="_blank"
                                    rel="noreferrer"
                                    className="text-dark"
                                >
                                    <i className="fas fa-file-pdf fa-3x pdf-icon" />
                                    <p>Anti Ragging Policy</p>
                                </a>
                            </div>
                            <div className="col-md-3 mb-4 lnk-crad">
                                <a
                                    href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/pdf-files/Grivence-redressal.pdf"
                                    target="_blank"
                                    rel="noreferrer"
                                    className="text-dark"
                                >
                                    <i className="fas fa-file-pdf fa-3x pdf-icon" />
                                    <p>Grievance Redressal Policy</p>
                                </a>
                            </div>
                            <div className="col-md-3 mb-4 lnk-crad">
                                <a
                                    href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/07/Antiragging-information%20_CCSU%20Meerut_2024-25.pdf"
                                    target="_blank"
                                    rel="noreferrer"
                                    className="text-dark"
                                >
                                    <i className="fas fa-file-pdf fa-3x pdf-icon" />
                                    <p>Contact Details (Nodal Officers)</p>
                                </a>
                            </div>
                            {/* Repeat this block for other PDF files */}
                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}

export default Main;